import { ConnectionManagerNetworkKeys as networkKeys } from '../constants';

export default function updateRequestBodyFactory(connection) {
  const baseRequestObject = {
    label: connection.title.trim(),
  };

  if (connection.network.type === networkKeys.PIGEON_HOLE) {
    if (connection.apiKey?.length > 0) {
      baseRequestObject.apiKey = connection.apiKey.trim();
    }
  }

  return baseRequestObject;
}
